

function PreNosia({monthsMissing}){
    const isPreNosia = monthsMissing <= 1;

    return isPreNosia ? "Yes" : "No";

}

export default PreNosia;